module.exports = require("@git-stack/client-react");